import digitalData from 'digital-data';
import {
  INTERACTION, PIP_SUB_CONTENT, OVERLAY, GEN_MERCH_BUNDLE, BIP_PAGE
} from '../constants';
import { getState } from '../analytics-state';

export const swapitem = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('swap-item.success', ({ output = { position: 'n/a' } }) => {
    const { position } = output;
    const { packageCategory, pageType = '' } = getState() || {};
    digitalData.event = digitalData.event || [];
    if (packageCategory === 'gm') {
      digitalData.event.push({
        category: {
          primaryCategory: OVERLAY
        },
        eventInfo: {
          eventName: GEN_MERCH_BUNDLE
        }
      });
    } else {
      const isBipPage = pageType === BIP_PAGE;
      const DDOEvent = {
        category: {
          primaryCategory: INTERACTION,
        },
        eventInfo: {
          eventName: PIP_SUB_CONTENT,
        },
        subContent: {
          component: 'swap',
          position,
          section: isBipPage ? BIP_PAGE : 'package',
          target: 'drawer',
        },
      };
      digitalData.event.push(DDOEvent);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('swap-item.error', ({ output = {} }) => {
    const DDOEvent = {
      category: {
        primaryCategory: 'error'
      },
      eventInfo: {
        eventName: 'post page error'
      }
    };
    const { message, code } = output;
    const isClientError = code >= 400 && code < 500;
    const errorObject = {
      type: isClientError ? 'error' : 'system',
      displayType: 'inline',
      pageSection: 'swap drawer',
      message,
      code
    };
    if (Array.isArray(DDOEvent.eventInfo.error)) {
      DDOEvent.eventInfo.error.push(errorObject);
    } else {
      DDOEvent.eventInfo.error = [errorObject];
    }
    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};